export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Details',
    pathname: '/',
    hash: '#details',
  },
  // {
  //   label: 'Articles',
  //   pathname: '/articles',
  // },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'Twitter',
    url: 'https://twitter.com/iamausafhussain',
    icon: 'twitter',
  },
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/ausafhxn',
    icon: 'instagram',
  },
  {
    label: 'Github',
    url: 'https://github.com/iamausafhussain',
    icon: 'github',
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/ausaf-hussain-4425b2195/',
    icon: 'linkedin',
  },
];
